import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useState } from 'react'
import { AiFillEyeInvisible, AiFillEye } from 'react-icons/ai'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ChangeUserPassword } from '../../services/manageUserServices';
import { fetchUsers } from '../../redux/slices/userSlice';
import { toast } from 'react-toastify';
import ButtonLoader from '../../components/ButtonLoader';

const ChangePassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);


useEffect(() =>{
  dispatch(fetchUsers())
}, [dispatch])

  const formik = useFormik({
      initialValues: {
          email: "",
          oldPassword: "",
          newPassword: "",
      },
      validationSchema: Yup.object({
          email: Yup.string().email('Invalid email address').required('Email is required'),
          oldPassword: Yup.string().min(6, '').required('password is required'),
          newPassword: Yup.string().min(6, 'Password must be at least 6 characters').required('password is required'),
      }),
      onSubmit: async (values) => {
        setLoading(true);

        try {
          const res = await ChangeUserPassword(values)
        if (res.statusCode === 200) {
          dispatch(fetchUsers())
          toast.success(res.message);
          setLoading(false)
          formik.resetForm()
          navigate('/settings'); 
        } else if (res.statusCode === 201) {
          toast.error(res.message);
          setLoading(false)
        } else if(res?.statusCode === 404){
          toast.error(res.message)
          setLoading(false)
        } else {
          toast.error(res.message)
          setLoading(false)
        }
        } catch (error) {
          toast.error('An error occurred during user creation');
          setLoading(false)
        } finally {
        }
    }
  });

  return (
    <div className="flex items-center justify-center h-full">
      <div className="bg-white p-7 border rounded-xl max-w-md">
        <h3 className="text-2xl text-center px-4 text-[#FF0000]">
          Change Password
        </h3>
        <p className="text-center text-sm mt-4 text-[#0A0A0ACC]">
        Strengthen your security—update your password regularly to keep your account safe and protected.
        </p>
        <form onSubmit={formik.handleSubmit} className="px-8 pt-8 pb-0">
          <label id="email" className='text-sm'>Email</label>
          <div className="mt-2 mb-3 relative">
            <input
              id="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="email"
              className="border border-[#00000] border-opacity-30 rounded-md px-4 w-full py-1.5 outline-none ring-0 placeholder:text-sm"
              type='text'
            />
            {formik.touched.email && formik.errors.email ? (
                    <div className='text-sm mt-1 text-red-500'>{formik.errors.email}</div>
              ) : null 
            }
          </div>
          <label id="old Password" className='text-sm'>Old Password</label>
          <div className="mt-2 mb-3 relative">
            <input
              id="oldPassword"
              name="oldPassword"
              value={formik.values.oldPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="old password"
              className="border border-[#00000] border-opacity-30 rounded-md px-4 w-full py-1.5 outline-none ring-0 placeholder:text-sm"
              type={showPassword ? "text" : "password"}
            />
            {formik.touched.oldPassword && formik.errors.oldPassword ? (
                    <div className='text-sm mt-1 text-red-500'>{formik.errors.oldPassword}</div>
              ) : null 
            }
            {showPassword ? (
              <AiFillEye className='absolute right-3 top-2 text-xl cursor-pointer text-gray-300' onClick={() => setShowPassword(prevState => !prevState)} />) : (
              <AiFillEyeInvisible className='absolute right-3 top-2 text-xl cursor-pointer text-gray-300' onClick={() => setShowPassword(prevState => !prevState)} />
            )
            }
          </div>
          <label id="newPassword" className='text-sm'>Confirm Password</label>
          <div className="mt-2 mb-3 relative">
            <input
              id="newPassword"
              name="newPassword"
              value={formik.values.newPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="new password"
              className="border border-[#00000] border-opacity-30 rounded-md px-4 w-full py-1.5 outline-none ring-0 placeholder:text-sm"
              type={showPassword ? "text" : "password"}
            />
            {formik.touched.newPassword && formik.errors.newPassword ? (
                    <div className='text-sm mt-1 text-red-500'>{formik.errors.newPassword}</div>
              ) : null 
            }
            {showPassword ? (
              <AiFillEye className='absolute right-3 top-2 text-xl cursor-pointer text-gray-300' onClick={() => setShowPassword(prevState => !prevState)} />) : (
              <AiFillEyeInvisible className='absolute right-3 top-2 text-xl cursor-pointer text-gray-300' onClick={() => setShowPassword(prevState => !prevState)} />
            )
            }
          </div>
          <button
            type='submit'
            disabled={loading}
            className="bg-[#FF0000] hover:bg-opacity-50 text-white py-2 w-full rounded-md text-sm mt-6"
            >
            {loading ? <ButtonLoader />
            : <span>Update Password</span>
            }
          </button>
        </form>
      </div>
    </div>
  );
};
export default ChangePassword;
